// extracted by mini-css-extract-plugin
module.exports = {"red_text":"red_text__mfkiZiAVRH46r","sample_wrapper":"sample_wrapper__yUWyzjRRXwFa9"};